import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import React, { useState, useEffect, useMemo } from "react";
// Data
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import CustomerEdit from "./edits/CustomerEdit";
import buildCustomerTable from "./data/customerTableData";
import apis from "../../context/api";
import NoAccess from "components/NoAccess";
import { canView, canCreate, canUpdate } from "context/permissions";

function Customers() {
  const allowView = canView("Customer");
  const allowCreate = canCreate("Customer");
  const allowUpdate = canUpdate("Customer");
  const [customerUpdate, setCustomerUpdate] = useState(false);
  const [id, setId] = useState(null);
  const [customerList, setCustomerList] = useState([]);
  const [customerSearch, setCustomerSearch] = useState("");
  const handleCancel = () => {
    setCustomerUpdate(false);
  };
  const customerUpdated = () => {
    setCustomerUpdate(false);
    loadTableData();
  };
  useEffect(() => {
    loadTableData();
  }, []);
  const editCustomer = (id) => {
    setId(id);
    setCustomerUpdate(true);
  };

  const loadTableData = async () => {
    try {
      apis
        .getCustomers()
        .then((data) => {
          setCustomerList(Array.isArray(data) ? data : []);
        })
        .catch((err) => {
          throw new Error("Can not get Customers");
        });
    } catch (err) {
      console.error("Data loading error:", err);
    }
  };

  const customerData = useMemo(() => {
    const q = customerSearch.trim().toLowerCase();
    const filtered = customerList.filter((item) => {
      if (!q) return true;
      const fields = [item.storeName, item.name, item.email, item.phone];
      return fields.some((f) => (f || "").toString().toLowerCase().includes(q));
    });
    return buildCustomerTable(filtered, (cid) => editCustomer(cid), allowUpdate);
  }, [customerList, customerSearch, allowUpdate]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {customerUpdate && (
        <CustomerEdit onSuccess={customerUpdated} v id={id} onCancel={handleCancel} />
      )}
      {!customerUpdate && !allowView && (
        <MDBox pt={6} pb={6}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <NoAccess message="You do not have permission to view Customers." />
            </Grid>
          </Grid>
        </MDBox>
      )}
      {!customerUpdate && allowView && (
        <MDBox pt={6} pb={6}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Customers
                  </MDTypography>
                </MDBox>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                  px={2}
                  pt={2}
                >
                  <Grid item xs={12} sm={6} md={4}>
                    <MDInput
                      fullWidth
                      label="Search by name, email or phone"
                      value={customerSearch}
                      onChange={(e) => setCustomerSearch(e.target.value)}
                    />
                  </Grid>
                  {allowCreate && (
                    <Grid item>
                      <MDButton
                        variant="gradient"
                        color="info"
                        onClick={() => {
                          setId(null);
                          setCustomerUpdate(true);
                        }}
                      >
                        Create
                      </MDButton>
                    </Grid>
                  )}
                </Grid>
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns: customerData.columns, rows: customerData.rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default Customers;
